/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
/**
 * Constant definitions
 */

export const AZURE_COOKIE_NAME = 'myAzureProxySession';
export const AZURE_TOKEN_SILENT_INTERVAL = 540000;
export const DEFAULT_COOKIE_EXPIRES = 'Thu, 01 Jan 1970 00:00:00 UTC';
// Tenants
export const DEFAULT_TENANT = 'aistudytool';
export const AI_STUDY_TOOL = 'aistudytool';
export const CHANNELS = 'channels';
export const PVS = 'pvs';
export const ECOMM = 'ecomm';
export const CUSTOMER_SUPPORT = 'customersupport';
export const ELS = 'els';

export const FILTER_TYPE = 'FILTER_TYPE';

export const MANAGE_USERS_DATA_FETCHED = 'MANAGE_USERS_DATA_FETCHED';
export const GET_USERS_PERMISSIONS = 'GET_USERS_PERMISSIONS';
export const USERS_PERMISSIONS_FETCHED = 'USERS_PERMISSIONS_FETCHED';
export const MANAGE_USERID = 'MANAGE_USERID';
export const ADD_USER_DATA = 'ADD_USER_DATA';
export const EDIT_USER_DATA = 'EDIT_USER_DATA';
export const GET_USER_ROLES = 'USER_ROLES';

export const USER_DETAILS_FETCHED = 'USER_DETAILS_FETCHED';

export const GET_TENANT_LIST_DATA = 'GET_TENANT_LIST_DATA';
export const SET_TENANT_LIST_DATA = 'SET_TENANT_LIST_DATA';
export const GET_PROVIDERS_LIST_DATA = 'GET_PROVIDERS_LIST_DATA';
export const SET_PROVIDERS_LIST_DATA = 'SET_PROVIDERS_LIST_DATA';
export const GET_TENANT_LIST_DATA_URL = 'chatutility/getTenantsList';
export const SELECT_TENANT_LIST = 'Please Select Tenant Name and Edit Provider Details';
export const SELECT_TENANT_LABEL = 'Select Tenant';
export const SELECT_MODEL = 'Select Model';
export const SELECT_PROVIDER = 'Select Provider';
export const SELECT_FEATURE = 'Select Feature';
export const ADD_NEW_MODEL = 'Add New Config';
export const UPDATE_PROVIDER_DATA_URL = '/chatutility/updateProvidersList';
export const ADD_PROVIDER_DATA_URL = '/chatutility/addProvidersList';
export const GET_TENANTS_LIST_URL = '/chatutility/getTenantsList';
export const ADD_NEW_PROMPT_TYPE = 'Add New Prompt Type';
export const REPORT_DOWNLOAD_SQS_URL = '/chatgptutility/report/generatereport';
export const REPORT_DOWNLOAD_S3_URL = '/chatgptutility/report/download';

export const GET_SYSTEM_TOKEN_URL = 'token/system';
export const GET_CDN_TOKEN_URL = 'token/cdn';
export const ETEXT_CDN_TOKEN_COOKIE_NAME = 'etext-cdn-token';

// Chat Utility
export const BOOK_ID = 'Book Id';
export const CHAT_CRITERIA_TEXT = 'Please enter search criteria to fetch the details';
export const CHAT_SEARCH = 'SEARCH';
export const CHAT_RESET = 'RESET';
export const CHAT_EXPORT = 'EXPORT';
export const CHAT_FETCH = 'Please search to fetch data ...';
export const CHAT_USERLOGIN = 'User Id';
export const CHAT_PROMPT = 'Prompt';
export const CHAT_SAFETY = 'Safety';
export const USER_ID = 'User Id';
export const REQUEST_ID = 'Request Id';
export const SELECT = 'Select';
export const TITLE = 'Title';
export const TYPE = 'Type';
export const SEARCH = 'Search';
export const PRODUCT_TYPE = 'Product Type';
export const CHAT_AUTHOR = 'Author';
export const CHAT_USERTOPIC = 'userTopic';
export const CHAT_PROMPT_CONTENT = 'Prompt With Content';
export const CHAT_PROMPT_CONTEXT = 'Prompt With Context';
export const DATE_TIME = 'Date / Time';
export const GET_CHATGPT_DATA = 'GET_CHATGPT_DATA';
export const GET_CHATGPT_USER_TOC_DATA = 'GET_CHATGPT_USER_TOC_DATA';
export const GET_CHATGPT_IES_USER_DATA = 'GET_CHATGPT_IES_USER_DATA';
export const SET_CHATGPT_IES_USER_DATA = 'SET_CHATGPT_IES_USER_DATA';
export const SET_CHATGPT_USER_TOC_DATA = 'SET_CHATGPT_USER_TOC_DATA';
export const SET_CHATGPT_MAPPING_DATA = 'SET_CHATGPT_MAPPING_DATA';
export const GET_CHATGPT_FEEDBACK_DATA = 'GET_CHATGPT_FEEDBACK_DATA';
export const GET_CHATGPT_RESPONSE_DATA = 'GET_CHATGPT_RESPONSE_DATA';
export const GET_USER_AUDIT_DATA = 'GET_USER_AUDIT_DATA';
export const GET_USER_AUDIT_FEEDBACK_DATA = 'GET_USER_AUDIT_FEEDBACK_DATA';
export const GET_USER_AUDIT_FEEDBACK_RESPONSE = 'GET_USER_AUDIT_FEEDBACK_RESPONSE';
export const GET_USER_AUDIT_DATA_RESPONSE = 'GET_USER_AUDIT_DATA_RESPONSE';
export const GET_FEEDBACK_OVERLAY_DATA_RESPONSE = 'GET_FEEDBACK_OVERLAY_DATA_RESPONSE';

export const GET_USER_AUDIT_SUB_TYPE_DATA = 'GET_USER_AUDIT_SUB_TYPE_DATA';
export const GET_USER_AUDIT_SUB_DATA_RESPONSE = 'GET_USER_AUDIT_SUB_DATA_RESPONSE';

export const GET_AI_ADMIN_EXECUTION_LOGS = 'GET_AI_ADMIN_EXECUTION_LOGS';
export const GET_AI_ADMIN_EXECUTION_LOGS_RESPONSE = 'GET_AI_ADMIN_EXECUTION_LOGS_RESPONSE';
export const AI_ADMIN_EXECUTION_LOGS_STATUS = 'aiAdminExecutionLogsStatus';

export const GET_CHATGPT_SUB_TYPE_RESPONSE_DATA = 'GET_CHATGPT_SUB_TYPE_RESPONSE_DATA';
export const SET_CHATGPT_SUB_TYPE_RESPONSE_DATA = 'SET_CHATGPT_SUB_TYPE_RESPONSE_DATA';
export const GET_CHATGPT_TRENDS_DATA = 'GET_CHATGPT_TRENDS_DATA';
export const GET_TRENDS_COUNT_DATA = 'GET_TRENDS_COUNT_DATA';
export const GET_CHATGPT_RESPONSE_MODEL_DATA = 'GET_CHATGPT_RESPONSE_MODEL_DATA';
export const GET_CHATGPT_TRENDS_MODEL_DATA = 'GET_CHATGPT_TRENDS_MODEL_DATA';
export const GPT_RESPONSE = 'GPT_RESPONSE';
export const SET_CHATGPT_TOC_DATA = 'SET_CHATGPT_TOC_DATA';
export const GET_CHATGPT_TOC_DATA = 'GET_CHATGPT_TOC_DATA';
export const SET_AET_TOC_DATA = 'SET_AET_TOC_DATA';
export const ADD_AET_QUESTION_DATA = 'ADD_AET_QUESTION_DATA';
export const UPDATE_AET_QUESTION_DATA = 'UPDATE_AET_QUESTION_DATA';
export const SET_ADD_AET_QUESTION_DATA = 'SET_ADD_AET_QUESTION_DATA';
export const SET_UPDATE_AET_QUESTION_DATA = 'SET_UPDATE_AET_QUESTION_DATA';
export const SET_AET_TOPIC_DATA = 'SET_AET_TOPIC_DATA';
export const ADD_AET_TOPIC_DATA = 'ADD_AET_TOPIC_DATA';
export const UPDATE_AET_TOPIC_DATA = 'UPDATE_AET_TOPIC_DATA';
export const SET_ADD_AET_TOPIC_DATA = 'SET_ADD_AET_TOPIC_DATA';
export const SET_UPDATE_AET_TOPIC_DATA = 'SET_UPDATE_AET_TOPIC_DATA';
export const DELETE_AET_QUESTION_DATA = 'DELETE_AET_QUESTION_DATA';
export const SET_DELETE_AET_QUESTION_DATA = 'SET_DELETE_AET_QUESTION_DATA';
export const DELETE_AET_TOPIC_DATA = 'DELETE_AET_TOPIC_DATA';
export const SET_DELETE_AET_TOPIC_DATA = 'SET_DELETE_AET_TOPIC_DATA';
export const SET_SUMMARY_DATA = 'SET_SUMMARY_DATA';
export const SET_STUDYTOOL_EFFECTIVENESS_DATA = 'SET_STUDYTOOL_EFFECTIVENESS_DATA';
export const GET_STUDYTOOL_EFFECTIVENESS_DATA = 'GET_STUDYTOOL_EFFECTIVENESS_DATA';
export const GET_STUDYTOOL_EFFECTIVENESS_METADATA = 'GET_STUDYTOOL_EFFECTIVENESS_METADATA';
export const SET_STUDYTOOL_EFFECTIVENESS_METADATA = 'SET_STUDYTOOL_EFFECTIVENESS_METADATA';
export const GET_EVAL_REPORT_LIST = 'GET_EVAL_REPORT_LIST';
export const SET_EVAL_REPORT_LIST = 'SET_EVAL_REPORT_LIST';
export const EVAL_REPORT_LIST_URL = '/evaluation/list';
export const GET_EVAL_REPORT_COMPOSITE = 'GET_EVAL_REPORT_COMPOSITE';
export const SET_EVAL_REPORT_COMPOSITE = 'SET_EVAL_REPORT_COMPOSITE';
export const GET_EVAL_REPORT_PANEL_SCORE_DETAIL = 'GET_EVAL_REPORT_PANEL_SCORE_DETAIL';
export const GET_EVAL_REPORT_SCORE_DETAIL = 'GET_EVAL_REPORT_SCORE_DETAIL';
export const SET_EVAL_REPORT_SCORE_DETAIL = 'SET_EVAL_REPORT_SCORE_DETAIL';
export const GET_EVAL_REPORT_EXECUTION = 'GET_EVAL_REPORT_EXECUTION';
export const SET_EVAL_REPORT_EXECUTION = 'SET_EVAL_REPORT_EXECUTION';
export const GET_EVAL_BATCH_REPORT = 'GET_EVAL_BATCH_REPORT';
export const SET_EVAL_BATCH_REPORT = 'SET_EVAL_BATCH_REPORT';
export const EVAL_REPORT_URL = '/evaluation/report';
export const EVAL_RESULT_URL = '/evaluation';
export const EVAL_REPORT_QUALITY_GOOD = 'Good';
export const EVAL_REPORT_QUALITY_MIXED = 'Mixed';
export const EVAL_REPORT_QUALITY_LOW = 'Low';
export const EVAL_REPORT_QUALITY_BUCKETS = [
  EVAL_REPORT_QUALITY_GOOD,
  EVAL_REPORT_QUALITY_MIXED,
  EVAL_REPORT_QUALITY_LOW
];
export const EVAL_REPORT_BAND_EXCELLENT = 'Excellent';
export const EVAL_REPORT_BAND_ACCEPTABLE = 'Acceptable';
export const EVAL_REPORT_BAND_POOR = 'Poor';
export const EVAL_REPORT_BANDS = [EVAL_REPORT_BAND_EXCELLENT, EVAL_REPORT_BAND_ACCEPTABLE, EVAL_REPORT_BAND_POOR];
/** Legacy rubric rows without rubricVersion in MongoDB are treated as version 1. */
export const LEGACY_RUBRIC_VERSION = 1;
export const GET_EVAL_GRAPH_RUBRICS = 'GET_EVAL_GRAPH_RUBRICS';
export const SET_EVAL_GRAPH_RUBRICS = 'SET_EVAL_GRAPH_RUBRICS';
export const SEARCH_EVAL_RUBRIC_NAMES = 'SEARCH_EVAL_RUBRIC_NAMES';
export const SET_EVAL_RUBRIC_NAME_RESULTS = 'SET_EVAL_RUBRIC_NAME_RESULTS';
export const EVAL_RUBRIC_SEARCH_MIN_CHARS = 3;
export const EVAL_RUBRIC_SEARCH_RECENT_LIMIT = 7;
export const EVAL_RUBRIC_SEARCH_MATCH_LIMIT = 15;
export const EVAL_RUBRIC_SEARCH_DEBOUNCE_MS = 300;
export const EVAL_REPORT_GRAPH_COLUMN_ID = 'evalName';
export const GET_RUBRICS_LIST = 'GET_RUBRICS_LIST';
export const GET_RUBRICS_DETAIL = 'GET_RUBRICS_DETAIL';
export const UPDATE_RUBRICS_RUBRIC = 'UPDATE_RUBRICS_RUBRIC';
export const SET_UPDATE_RUBRICS_RUBRIC = 'SET_UPDATE_RUBRICS_RUBRIC';
export const DELETE_RUBRICS_RUBRIC = 'DELETE_RUBRICS_RUBRIC';
export const SET_DELETE_RUBRICS_RUBRIC = 'SET_DELETE_RUBRICS_RUBRIC';
export const CREATE_RUBRICS_RUBRIC = 'CREATE_RUBRICS_RUBRIC';
export const SET_CREATE_RUBRICS_RUBRIC = 'SET_CREATE_RUBRICS_RUBRIC';
export const SAVE_RUBRICS_SCHEDULER = 'SAVE_RUBRICS_SCHEDULER';
export const SET_SAVE_RUBRICS_SCHEDULER = 'SET_SAVE_RUBRICS_SCHEDULER';
export const CONSOLIDATED_REPORT_TREND_DEFAULT_CHART_WIDTH = 600;
export const CONSOLIDATED_REPORT_TREND_MIN_CHART_WIDTH = 480;
export const CONSOLIDATED_REPORT_TREND_CHART_HEIGHT = 220;
export const CONSOLIDATED_REPORT_TREND_CHART_PADDING = { top: 36, right: 24, bottom: 32, left: 44 };
export const CONSOLIDATED_REPORT_TREND_DATE_LABEL_OFFSET_BELOW_AXIS = 18;
export const CONSOLIDATED_REPORT_TREND_DATE_LABEL_MIN_SLOT = 20;
export const CONSOLIDATED_REPORT_TREND_DATE_LABEL_MONTH_MIN_SLOT = 30;
export const CONSOLIDATED_REPORT_TREND_DAY_TOOLTIP_Z_INDEX = 1800;
export const CONSOLIDATED_REPORT_TREND_DAY_TOOLTIP_POPPER_MODIFIERS = [
  { name: 'offset', options: { offset: [0, 12] } }
];
export const CONSOLIDATED_REPORT_TREND_DOT_HIT_RADIUS = 10;
export const CONSOLIDATED_REPORT_TREND_DOT_STACK_RADIUS = 4;
export const CUSTOM_EVAL = 'CUSTOM_EVAL';
export const SET_CUSTOM_EVAL = 'SET_CUSTOM_EVAL';
export const CUSTOM_EVAL_PATH_SUFFIX = '/custom-eval';
export const EVAL_CUSTOM_RANGE_DEFAULT_SPAN_DAYS = 7;
export const EVAL_CUSTOM_RANGE_SPAN_DAYS_CAP = 31;
export const TENANT_CUSTOM_EVAL_KEY = 'customEval';
export const EVAL_CUSTOM_RANGE_DATE_FORMAT = 'YYYY-MM-DD';
export const EVAL_CUSTOM_RANGE_DISPLAY_FORMAT = 'D MMM YYYY';
export const EVAL_CUSTOM_RANGE_DAY_MONTH_FORMAT = 'D MMM';
export const EVAL_CUSTOM_RANGE_DAY_FORMAT = 'D';
export const EVAL_CUSTOM_RANGE_DASH_STYLE = Object.freeze({
  sameMonthStartFormat: EVAL_CUSTOM_RANGE_DAY_FORMAT,
  sameMonthSeparator: '–',
  separator: ' – '
});
export const EVAL_CUSTOM_RANGE_TO_STYLE = Object.freeze({
  sameMonthStartFormat: EVAL_CUSTOM_RANGE_DAY_MONTH_FORMAT,
  sameMonthSeparator: ' to ',
  separator: ' to '
});
export const EVAL_CUSTOM_RANGE_ARROW_STYLE = Object.freeze({
  sameMonthStartFormat: EVAL_CUSTOM_RANGE_DAY_MONTH_FORMAT,
  sameMonthSeparator: ' → ',
  separator: ' → '
});
export const EVAL_CUSTOM_EVAL_REQUESTED_FORMAT = 'MMM D, YYYY h:mm A';
export const EVAL_BATCH_REPORT_DATE_TIME_FORMAT = 'D MMM YYYY, HH:mm:ss';
export const EVAL_BATCH_REPORT_TIME_FORMAT = 'HH:mm:ss';
export const EVAL_CUSTOM_RANGE_DAY_ROLE = Object.freeze({
  ANCHOR: 'anchor',
  EDGE: 'edge',
  INSIDE: 'inside'
});
export const EVAL_CUSTOM_RANGE_PARTIAL_SELECTION = 'partial';
export const DATE_UNIT_DAY = 'day';
export const DATE_UNIT_MONTH = 'month';
export const DATE_UNIT_YEAR = 'year';
export const KEYBOARD_KEY = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: ' ',
  TAB: 'Tab',
  CONTROL: 'Control',
  META: 'Meta'
};

export const isKeyboardActivationKey = (key) => key === KEYBOARD_KEY.ENTER || key === KEYBOARD_KEY.SPACE;
export const DOM_EVENT_KEYDOWN = 'keydown';
export const COL_LABEL_INPUT = 'Input';
export const COL_LABEL_OUTPUT = 'Output';
export const COL_LABEL_VERSION = 'Version';

export const SET_UPDATE_SUMMARY_DATA = 'SET_UPDATE_SUMMARY_DATA';
export const SET_SUMMARY_DATA_RESPONSE = 'SET_SUMMARY_DATA_RESPONSE';
export const GET_CHATGPT_SUMMARY_DATA = 'GET_CHATGPT_SUMMARY_DATA';
export const UPDATE_CHATGPT_SUMMARY_DATA = 'UPDATE_CHATGPT_SUMMARY_DATA';
export const UPDATE_CHATGPT_SUMMARY_DATA_STATUS = 'UPDATE_CHATGPT_SUMMARY_DATA_STATUS';
export const UPDATE_CHATGPT_PUBLISH_ALL_SUMMARY_DATA_STATUS = 'UPDATE_CHATGPT_PUBLISH_ALL_SUMMARY_DATA_STATUS';
export const DELETE_CHATGPT_SUMMARY_DATA = 'DELETE_CHATGPT_SUMMARY_DATA';
export const FETCH_MCQ_SEARCH_DATA = 'FETCH_MCQ_SEARCH_DATA';
export const SET_MCQ_SEARCH_DATA = 'SET_MCQ_SEARCH_DATA';
export const MCQ_QUESTION_UPDATE_STATUS = 'MCQ_QUESTION_UPDATE_STATUS';
export const MCQ_QUESTION_DELETE_STATUS = 'MCQ_QUESTION_DELETE_STATUS';
export const SET_MCQ_COMMENT_SUCCESS = 'SET_MCQ_COMMENT_SUCCESS';
export const SET_SUMMARY_COMMENT_SUCCESS = 'SET_SUMMARY_COMMENT_SUCCESS';
export const ADD_MCQ_COMMENT = 'ADD_MCQ_COMMENT';
export const ADD_SUMMARY_COMMENT = 'ADD_SUMMARY_COMMENT';
export const PUBLISHED_STATUS = 'PUBLISHED';
export const PUBLISH_ALL = 'Publish All';
export const PUBLISHED_ALL_STATUS = 'PUBLISHED_ALL';
export const MCQ_QUESTION_UPDATE_PUBLISHED_ALL_STATUS = 'MCQ_QUESTION_UPDATE_PUBLISHED_ALL_STATUS';
export const DELETED_STATUS = 'DELETED';
export const REVIEW_STATUS = 'REVIEW';
export const UPDATE_MCQ_QUESTION_DATA = 'UPDATE_MCQ_QUESTION_DATA';
export const ADD_MCQ_QUESTION_DATA = 'ADD_MCQ_QUESTION_DATA';
export const SET_UPDATE_MCQ_QUESTION_DATA = 'SET_UPDATE_MCQ_QUESTION_DATA';
export const SET_ADD_MCQ_QUESTION_DATA = 'SET_ADD_MCQ_QUESTION_DATA';
export const GPT_FEEDBACK_RESPONSE = 'GPT_FEEDBACK_RESPONSE';
export const GET_CHATGPT_MAPPING_DATA = 'GET_CHATGPT_MAPPING_DATA';
export const CONTENT_FILTER_BLOCKED = 'Content Filter (Blocked)';
export const GET_CHATGPT_LISTING_DATA = 'GET_CHATGPT_LISTING_DATA';
export const GET_TRENDS_CLUSTER_LIST = 'GET_TRENDS_CLUSTER_LIST';
export const GET_CHATGPT_LISTING_MODEL_DATA = 'GET_CHATGPT_LISTING_MODEL_DATA';
export const GET_TRENDS_CLUSTER_LISTING_DATA = 'GET_TRENDS_CLUSTER_LISTING_DATA';
export const CLUSTER_LIST = 'Cluster List';
export const CLUSTERING = 'Clustering';
export const COUNT = 'Count';
export const TRENDS_COUNT_SHOW_TREND_LINE_DATA = 'showTrendLineData';
export const TRENDS_COUNT_DATE_COLUMN_ID = 'date';
export const TRENDS_COUNT_UNKNOWN_LABEL = 'Unknown';
export const TRENDS_COUNT_TREND_LINE_WINDOW = Object.freeze({
  SEVEN_DAYS: 7,
  THIRTY_DAYS: 30,
  FULL: 'full'
});
export const TRENDS_COUNT_KPI_CORE_FEATURE_IDS = Object.freeze([
  'explainCount',
  'quizMcqCount',
  'summaryCount',
  'problemSolveCount',
  'likeCount',
  'disLikeCount'
]);
/** Like/Dislike series rendered on a separate trend-line chart from usage features. */
export const TRENDS_COUNT_TREND_LINE_FEEDBACK_FEATURE_IDS = Object.freeze(['likeCount', 'disLikeCount']);
/** Usage series = core KPI features excluding feedback (Like/Dislike). */
export const TRENDS_COUNT_TREND_LINE_USAGE_FEATURE_IDS = Object.freeze(
  TRENDS_COUNT_KPI_CORE_FEATURE_IDS.filter((id) => !TRENDS_COUNT_TREND_LINE_FEEDBACK_FEATURE_IDS.includes(id))
);
export const TRENDS_COUNT_TOP_IDENTIFIERS_LIMIT = 5;
export const TRENDS_COUNT_KPI_EXTRA_FEATURE_LIMIT = 2;
export const TRENDS_COUNT_TREND_LINE_FEATURE_GROUP = Object.freeze({
  ALL: 'all',
  USAGE: 'usage',
  FEEDBACK: 'feedback'
});
/** Shared trend chart series mode (Feedback / Usage). */
export const TRENDS_COUNT_TREND_LINE_SERIES_MODE = Object.freeze({
  FEEDBACK: 'feedback',
  USAGE: 'usage'
});
/** Individual series vs single combined daily total over the selected window. */
export const TRENDS_COUNT_TREND_LINE_COUNT_MODE = Object.freeze({
  INDIVIDUAL: 'individual',
  CUMULATIVE: 'cumulative'
});
export const TRENDS_COUNT_CHART_BAR_SLOT_HEIGHT = 40;
export const TRENDS_COUNT_CHART_BASE_PADDING = 88;
export const TRENDS_COUNT_CHART_MIN_HEIGHT = 160;
export const TRENDS_COUNT_CHART_MAX_HEIGHT = 320;
export const TRENDS_COUNT_CHART_MAX_BAR_THICKNESS = 28;
export const TRENDS_COUNT_TREND_LINE_CHART_HEIGHT = 280;
export const TRENDS_COUNT_TREND_LINE_AUTO_SKIP_DAY_THRESHOLD = 14;

// OTEL (Agent SDK) Count report. Features are dynamic agent names rather than fixed count columns.
export const GET_OTEL_TRENDS_COUNT_DATA = 'GET_OTEL_TRENDS_COUNT_DATA';
export const OTEL_TRENDS_COUNT_STATUS = 'otelTrendsCountStatus';
export const OTEL_TRENDS_COUNT_ENDPOINT = '/otel/trends/count';
export const OTEL_TRENDS_COUNT_EXPORT_ENDPOINT = '/otel/trends/count/export';
export const GET_OTEL_TRENDS_COUNT_EXPORT_DATA = 'GET_OTEL_TRENDS_COUNT_EXPORT_DATA';
export const OTEL_TRENDS_COUNT_EXPORT_STATUS = 'otelTrendsCountExportStatus';
/** Keeps synthesized agent column ids from colliding with title/identifierId/likeCount/etc. */
export const OTEL_AGENT_FEATURE_ID_PREFIX = 'agent::';
export const OTEL_TRENDS_COUNT_KPI_LIMIT = 4;
/** Agent names are unbounded, so Usage by Agent and the trend line show only the busiest agents. */
export const OTEL_TRENDS_COUNT_AGENT_CHART_LIMIT = 5;
export const OTEL_AGENT_COUNT_FIELD = 'agentCount';
export const OTEL_AGENT_NAME_FIELD = 'agentName';
export const REPORT_SUMMARY_STAT_VARIANT = Object.freeze({
  DEFAULT: 'default',
  LARGE: 'large',
  SCOPE: 'scope'
});
export const REPORT_SUMMARY_VALUE_CLASS_BY_VARIANT = Object.freeze({
  [REPORT_SUMMARY_STAT_VARIANT.LARGE]: 'summaryStatValueLarge',
  [REPORT_SUMMARY_STAT_VARIANT.SCOPE]: 'summaryStatValueScope'
});
export const REPORT_SUMMARY_DEFAULT_VALUE_CLASS = 'summaryStatValue';
export const USER_FEEDBACK_CHART = 'User Feedback Chart';
export const USER_BLOCKED_CHART = 'Blocked Count Chart';
export const USER_FEEDBACK_SHORT = 'Feedback';
export const USER_BLOCKED_SHORT = 'Blocked';
export const CANCEL = 'Cancel';
export const SAVE = 'Save';
export const ADMIN_SCREEN = 'Admin';
export const SAVE_ADMIN_DATA = 'SAVE_ADMIN_DATA';
export const SET_ADMIN_DATA = 'SET_ADMIN_DATA';
export const GET_ADMIN_DATA = 'GET_ADMIN_DATA';
export const EDIT_ADMIN_DATA = 'EDIT_ADMIN_DATA';
export const BOOK_STATUS_COLUMN_NAME = 'Status';

export const GPT_TABLECONTENT = 'Table Of Contents';
export const GPT_TOTALCHAPTER = 'Total Chapter questions';
export const GPT_TOCMODIFIED = 'Modified By';
export const GPT_STATUS = 'Status';
export const GPT_LASTMODIFIED = 'Last Modified';
export const GPT_TOTALPAGE = 'Total Page questions';
export const GPT_DIFFICULTY = 'Difficulty';
export const GPT_BLOOMLEVEL = 'Bloom Level';
export const GPT_MISCONCEPTION_TAG = 'Misconception tag';
export const GPT_EDITQUESTION = 'Edit';
export const GPT_ADDQUESTION = 'Add';
export const GPT_DELETEQUESTION = 'Delete';
export const GPT_PUBLISHALL = 'Publish';
export const GPT_UN_PUBLISH = 'Un-Publish';
export const GPT_NOQUESTON = 'No question....Please add question';
export const GPT_NOSUMMARY = 'No summary found...';
export const GPT_UNPUBLISH_DIALOG_TEXT = 'Are you Sure to Un-Publish?';

// Titles

export const FETCH_BOOK_TITLES_DATA = 'FETCH_BOOK_TITLES_DATA';
export const SET_BOOK_TITLES_DATA = 'SET_BOOK_TITLES_DATA';
export const GET_BOOK_TITLES_URL = '/tenant/identifiers';
export const FETCH_AUDIT_GRAPH_TITLES_DATA = 'FETCH_AUDIT_GRAPH_TITLES_DATA';
export const SET_AUDIT_GRAPH_TITLES_DATA = 'SET_AUDIT_GRAPH_TITLES_DATA';
export const AUDIT_GRAPH_TITLES_STORE = 'auditGraphTitles';
export const AUDIT_GRAPH_TITLES_SERVICE_STATUS = 'GetAuditGraphTitlesServiceStatus';

// Gpt Trends
export const CHAT_UTILITY_ANSWER = 'answer';
export const GPT_TRENDS_USER_INPUT = 'User Input';
export const GPT_TRENDS_COMMAND = 'User Command';
export const GPT_TRENDS_DATE = 'Date';
export const GPT_TRENDS_BOOKTITLE = 'Book Title';
export const GPT_TRENDS_LIKECOUNT = 'Like Count';
export const GPT_TRENDS_DISLIKECOUNT = 'Dislike Count';
export const GPT_TRENDS_EXPLAINCOUNT = 'Explain Count';
export const GPT_TRENDS_SUMMARYCOUNT = 'Summary Count';
export const GPT_TRENDS_QUIZCOUNT = 'Quiz Mcq Count';
export const GPT_TRENDS_PROBLEMSOLVECOUNT = 'Problem Solve Count';
export const GPT_TRENDS_BLOCKEDWORDCOUNT = 'Blocked Word Count';
export const GPT_TRENDS_UNKNOWNCOUNT = 'Unknown Count';
export const GPT_TRENDS_UNANSWEREDCOUNT = 'Un-Answered Count';
export const GPT_TRENDS_UNANSWERED_NO_CSG_DOCS_COUNT = 'Un-Answered (No RAG Docs) Count';
export const GPT_TRENDS_UNANSWERED_UNKNOWN_INTENT_COUNT = 'Un-Answered (Unknown Intent) Count';
export const GPT_TRENDS_UNANSWERED_NO_TOPIC_FOUND_COUNT = 'Un-Answered (No Topic Found) Count';
export const GPT_TRENDS_BLOCKED_COUNT = 'Blocked Count';

export const PVS_INGESTION_URL = '/chatUtility/getPVSIngestionStatus';
export const PVS_INGESTION_DATA_URL = '/chatUtility/geIngestionFilteredData';

export const SEPARATOR = '/';
export const PIPE = '|';
export const ICON_HOTSPOT = 1;
export const PAGE_HOTSPOT = 2;

export const MM_DD_YYYY_FORMAT = 'MM/DD/YYYY';
export const DISPLAY_DATE_FORMAT = 'DD MMM, YYYY';
export const YYYY_MM_DD_FORMAT = 'YYYY/MM/DD';
export const YYYY_MM_DD_HYPHEN_FORMAT = 'YYYY-MM-DD';
export const YYYY_MM_DD_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const YYYY_MM_DD_START_OF_DAY_FORMAT = 'YYYY-MM-DD 00:00:00';
export const YYYY_MM_DD_END_OF_DAY_FORMAT = 'YYYY-MM-DD 23:59:59';
export const DD_MM_YYYY_FORMAT = 'DD-MM-YYYY';
export const PEARSON_PRIMARY_COLOR = '#005d83';

export const YES = 'Y';
export const NO = 'N';

export const EMAIL_PATTERN = new RegExp(
  [
    '^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)',
    '|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.',
    '[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+',
    '[a-zA-Z]{2,}))$'
  ].join('')
);

export const DEFAULT_FILTER_VALUES = [
  'search_overview',
  'math_mcq_validation',
  'physics_mcq_validation',
  'recommendations',
  'summary_gen',
  'quiz_topic_practice2',
  'quiz_topic_practice1',
  'expertdeck_mcq',
  'expertdeck_free_response',
  'problem_solve',
  'explain_stand_alone',
  'quiz_mcq',
  'mcq_question_generation',
  'quiz_free_response',
  'free_response',
  'quiz_intent',
  'mcq_distract',
  'quiz_validate_intent',
  'mcq_misconceptions',
  'mcq_skill_identifier',
  'summary_topic',
  'summary-enrichment',
  'content_classifier',
  'chat_enrichment',
  'topic',
  'chat_intent',
  'mcq',
  'flashcards',
  'answer',
  'discuss',
  'dictionary_summary',
  'dictionary_quiz',
  'salutation',
  'context_identifier_user_selection',
  'summary_explain',
  'answer_cyu_mcq',
  'problem_solve_rectifier',
  'quiz',
  'non_math_mcq_validation',
  'math_mcq_core_concepts',
  'math_mcq_question_generation',
  'math_mcq',
  'summary_gpt4o',
  'physics_mcq',
  'physics_mcq_question_generation',
  'generate_python',
  'problem_solve_final_response',
  'history_title',
  'context_identifier_summary',
  'specific_topic_intent_identifier',
  'context_identifier_summary_topic',
  'context_identifier_quiz',
  'channel_fetch'
];

export const DEFAULT_CHANNELS_VALUES = [
  'find_relevant_topics',
  'generate_answer_explaination',
  'proxy_content_filter',
  'generate_video_summary',
  'generate_topic_summary',
  'generate_question_intent',
  'generate_question_explanation',
  'generate_question_steps_and_solution',
  'generate_question_solution',
  'generate_chat_example_question',
  'generate_solution_steps',
  'get_topic_by_user_query'
];

export const FILTER_PROMPT = {
  ...Object.fromEntries([AI_STUDY_TOOL, PVS].map((key) => [key, DEFAULT_FILTER_VALUES])),
  channels: [...DEFAULT_CHANNELS_VALUES]
};

export const ALLOWED_KEYS_MAPPING = ['questionType', 'topicName', 'chapterName'];
export const GENERATE_STUDY_GUIDE_MAP_TOPICS = 'generate_study_guide_map_to_topics';
export const GENERATE_STUDY_GUIDE_AI_NOTES = 'generate_study_guide_ai_notes';
export const GENERATE_STUDY_GUIDE_PRACTICE_PROBLEMS = 'generate_study_guide_practice_problems';
export const GENERATE_KEY_CONCEPTS_RS_PAGE = 'generate_key_concepts_RS_page';
export const GENERATE_STUDY_GUIDE_FLASHCARDS = 'generate_study_guide_flashcards';
export const SEARCH_OVERVIEW_TYPE = 'search_overview';
export const NON_MATH_MCQ_VALIDATION = 'non_math_mcq_validation';
export const MATH_MCQ_CORE_CONCEPTS = 'math_mcq_core_concepts';
export const MATH_MCQ_QUESTION_GENERATION = 'math_mcq_question_generation';
export const MATH_MCQ = 'math_mcq';
export const commonAuditTypesResponse = [
  'search_overview',
  'math_mcq_validation',
  'physics_mcq_validation',
  'recommendations',
  'quiz_topic_practice1',
  'quiz_topic_practice2',
  'non_math_mcq_validation',
  'math_mcq_core_concepts',
  'math_mcq_question_generation',
  'math_mcq',
  'summary_gpt4o',
  'summary_gen',
  'physics_mcq',
  'physics_mcq_question_generation',
  'generate_python',
  'problem_solve_final_response',
  'image_copilot_explain',
  'image_copilot_answer',
  'image_copilot_cyu',
  'image_copilot_cyu_evaluate',
  'image_copilot_intent_classifier'
];
export const ANSWER_CYU_MCQ = 'answer_cyu_mcq';
export const ASSET_SYNC_REQUESTED = 'ASSET_SYNC_REQUESTED';
export const ASSET_STATUS_REQUESTED = 'ASSET_STATUS_REQUESTED';
export const TENANT_LIST_TEXT = 'Please select Product to view the Audit Logs';
export const SELECT_PRODUCT_LABEL = 'Select Product';
export const TENANT_SEARCH_BUTTON = 'GO';
export const GET_CHANNELS_DATA = 'GET_CHANNELS_DATA';
export const GET_CHANNELS_SUB_TYPE_DATA = 'GET_CHANNELS_SUB_TYPE_DATA';
export const GET_CHANNELS_MODEL_DATA = 'GET_CHANNELS_MODEL_DATA';
export const CHANNELS_MODEL_RESPONSE = 'CHANNELS_MODEL_RESPONSE';
export const CHANNELS_SUB_TYPE_RESPONSE = 'CHANNELS_SUB_TYPE_RESPONSE';
export const CHANNELS_ANSWER_EXPLAINATION = 'generate_answer_explaination';
export const CHANNELS_RESPONSE = 'CHANNELS_RESPONSE';
export const CHANNELS_ID = 'Channels Id';
export const CHANNELS_ID_NAME = 'channelId';
export const BOOK_ID_NAME = 'bookId';
export const CHANNEL_ID_NAME = 'channelsId';
export const CLUSTER = 'cluster';
export const CHANNELS_FILTER_PROMPT = [
  'find_relevant_topics',
  'generate_answer_explaination',
  'proxy_content_filter',
  'generate_video_summary',
  'generate_topic_summary',
  'generate_question_intent',
  'generate_question_explanation',
  'generate_question_steps_and_solution',
  'generate_question_solution'
];
export const FLASHCARD_TYPE = 'flashcard';
export const GET_CHANNELS_LISTING_DATA = 'GET_CHANNELS_LISTING_DATA';
export const GET_CHANNELS_LISTING_MODEL_DATA = 'GET_CHANNELS_LISTING_MODEL_DATA';
export const RELEVANT_TOPICS = 'find_relevant_topics';
export const PROXY_CONTENT_FILTER = 'proxy_content_filter';
export const OTHER_TOPICS = 'Other topics';
export const CONTEXT_IDENTIFIER_USER_SELECTION = 'context_identifier_user_selection';
export const CHAT_INTENT_PROBLEM_SOLVE = 'chat_intent_problem_solve';
export const PROBLEM_SOLVE_FEATURE = 'problem_solve_feature';
export const CHAT_INTENT = 'chat_intent';
export const CONTENT_FILTER = 'content_filter';
export const GENERATE_TOPIC_SUMMARY = 'generate_topic_summary';
export const GENERATE_VIDEO_SUMMARY = 'generate_video_summary';
export const EXPERTDESK_MCQ = 'expertdeck_mcq';
export const EXPERTDESK_FREE_RESPONSE = 'expertdeck_free_response';
export const GENERATE_QUESTION_INTENT = 'generate_question_intent';
export const GET_CHANNELS_TRENDS_DATA = 'GET_CHANNELS_TRENDS_DATA';
export const GET_CHANNELS_TRENDS_MODEL_DATA = 'GET_CHANNELS_TRENDS_MODEL_DATA';
export const SIGNED_OUT_USER = 'Signed Out User';
export const SIGNED_OUT_USER_ID = 'ffffffff61bb375351b4d75952c2cb68';
export const CHANNELS_CHECKBOX_TYPE = [
  'find_relevant_topics',
  'generate_answer_explaination',
  'generate_video_summary',
  'generate_topic_summary',
  'generate_question_intent',
  'generate_question_explanation'
];
export const RELEVANT_TOPICS_COUNT = 'Relevant Topics Count';
export const GENERATE_VIDEO_SUMMARY_COUNT = 'Video Summary Count';
export const GENERATE_QUESTION_INTENT_COUNT = 'Question Intent Count';
export const SUMMARY_EXPLAIN = 'summary_explain';
export const GENERATE_QUESTION_EXPLAINATION = 'generate_question_explanation';
export const GENERATE_QUESTION_SOLUTION = 'generate_question_solution';
export const GENERATE_QUESTION_STEPS_AND_SOLUTION = 'generate_question_steps_and_solution';
export const GENERATE_QUESTIONS = 'generate_questions';
export const GENERATE_TOPIC_FAQ = 'generate_topic_FAQ';
export const VIEW = 'view';
export const DOWNLOAD = 'Download';
export const MONTHS = 'Months';
export const DISCUSS = 'discuss';
export const PROBLEM_SOLVE = 'problem_solve';
export const PROBLEM_SOLVE_RECTIFIER = 'problem_solve_rectifier';
export const PROBLEM_SOLVE_VERIFIER = 'problem_solve_verifier';
export const EXPLAIN_STAND_ALONE = 'explain_stand_alone';
export const SALUTATION = 'salutation';
export const TOPIC = 'topic';
export const MMMM_FORMAT = 'MMMM';
export const SELECT_MONTH = 'Select Month';
export const CURRENT_MONTH = 'current_month';
export const LAST_MONTH = 'last_month';
export const LAST_THREE_MONTH = 'last_three_month';
export const GENERATE_QUESTION_SOLUTION_COUNT = 'Question Solutions Count';
export const QUESTION_STEP_SOLUTION_COUNT = 'Question Step Solution Count';
export const REPORT_SIGNED_URL = '/chatutility/reports';
export const MMM_YYYY_FORMAT = 'MMM YYYY';
export const SAVE_ADMIN_PROMPTS_DATA = 'SAVE_ADMIN_PROMPTS_DATA';
export const SET_ADMIN_PROMPTS_DATA = 'SET_ADMIN_PROMPTS_DATA';
export const SET_ADMIN_PROMPTS_UPDATED_DATA = 'SET_ADMIN_PROMPTS_UPDATED_DATA';
export const GET_ADMIN_PROMPTS_DATA = 'GET_ADMIN_PROMPTS_DATA';
export const EDIT_ADMIN_PROMPTS_DATA = 'EDIT_ADMIN_PROMPTS_DATA';
export const DELETE_ADMIN_PROMPTS_DATA = 'DELETE_ADMIN_PROMPTS_DATA';
export const DELETE = 'DELETE';
export const AI_STUDY_TOOLS_TENANT_ID = '32e81240-7457-11ed-89c4-a117ea7cad6a';
export const PROMPT_ARCHIVED_STATUS = 'ARCHIVED';
export const PROMPT_LIVE_STATUS = 'LIVE';
export const GENERATE_PYTHON = 'generate_python';
export const PROBLEM_SOLVE_FINAL_RESPONSE = 'problem_solve_final_response';
export const SET_PROBLEM_SOLVE_FINAL_RESPONSE = 'SET_PROBLEM_SOLVE_FINAL_RESPONSE';
export const GET_PYTHON_GENERATION_DATA = 'GET_PYTHON_GENERATION_DATA';
export const GENERATE_PYTHON_AI_RESPONSE = 'Generate Python Response';
export const PROBLEM_SOLVE_FINAL_AI_RESPONSE = 'Problem Solve Final Response';
export const VERIFIER_FLOW = 'Verifier';
export const GENERATE_PYTHON_FLOW = 'GeneratePython';
export const LIVE_IN_PRODUCTION = 'Live in Production';

// TODO: Channels Tenant ID
export const CHANNELS_TENANT_ID = '';
export const SET_PROBLEM_SOLVE_DATA = 'SET_PROBLEM_SOLVE_DATA';
export const ADMIN_PROMPT_RESTORE_DIALOG_TEXT = 'Are you sure you want to restore this version and make this LIVE?';
export const ADMIN_PROMPT_PUBLISH_TEXT = 'Are you sure you want to Publish?';
export const ADMIN_PROMPT_SAVE_TEXT =
  'Previous version of same prompt is alread LIVE, to make this new edits LIVE, click on “Publish”';
export const PROMPT_DRAFT_STATUS = 'DRAFT';
export const INITIATE_NEW = 'INITIATE NEW';
export const DATE_TIME_GMT = 'Date/Time(GMT)';
export const S3_PATH = 'File Name';
export const SHOW_RESULTS = 'Show Results';
export const EXECUTED_BY = 'Executed By';
export const F1_SCORE_NAME = 'f1_score';
export const EFFECTIVENESS_INITIATE_DATA = 'EFFECTIVENESS_INITIATE_DATA';
export const EFFECTIVENESS_TRIGGER_FILE_UPLOAD = 'EFFECTIVENESS_TRIGGER_FILE_UPLOAD';
export const EFFECTIVENESS_SET_FILE_UPLOAD_RESPONSE = 'EFFECTIVENESS_SET_FILE_UPLOAD_RESPONSE';
export const EFFECTIVENESS_ENTITY_LLM = 'LLMEvaluation';
export const EFFECTIVENESS_ENTITY_REPORT = 'EvaluationReport';
export const EFFECTIVENESS_ENTITY_RUBRICS = 'Rubrics';
export const GET_ADMIN_PROMPTS_URL = '/chatutility/prompt/getprompt';
export const GET_BOOK_DATA_URL = '/chatutility/quizmcq/search';
export const GET_S3_USERS_LIST_URL = '/chatutility/getfiledata';
export const TYPE_QUIZ = 'quiz';
export const CHAT_ENRICHMENT = 'chat_enrichment';
export const DOWNLOAD_TEMPLATE = 'Download Template';

export const GET_COMMON_SEARCH_UTILITY_DATA = 'GET_COMMON_SEARCH_UTILITY_DATA';
export const GET_COMMON_SEARCH_UTILITY_RESPONSE = 'GET_COMMON_SEARCH_UTILITY_RESPONSE';
export const SUMMARY = 'Summary';
export const EXPLAIN = 'Explain';
export const QUIZ = 'Quiz';
export const PROBLEM_SOLVE_TYPE = 'Problem Solve';
export const EVALUATE = 'Evaluate';
export const RUN = 'Run';
export const ALL_BOOKS = 'All Books';
export const SUMMARY_TYPE = 'summary';
export const QUIZ_MCQ_TYPE = 'quiz_mcq';
export const EXPLAIN_TYPE = 'answer';
export const FEEDBACK_EXPLAIN_TYPE = 'discuss';
export const FEEDBACK_QUIZ_TYPE = 'quiz';
export const EXPLAIN_SUGGESTIONS = 'explain_suggestions';

// Tenant-scoped user management events (ai-admin module; distinct from ./users module)
export const MANAGE_USERS_DATA_FETCHED_TENANT = 'MANAGE_USERS_DATA_FETCHED_TENANT';
export const GET_USER_ROLES_TENANT = 'GET_USER_ROLES_TENANT';
export const ADD_USER_DATA_TENANT = 'ADD_USER_DATA_TENANT';
export const EDIT_USER_DATA_TENANT = 'EDIT_USER_DATA_TENANT';
export const DELETE_USER_DATA = 'DELETE_USER_DATA';
export const SET_ADDED_DATA = 'SET_ADDED_DATA';
export const SET_UPDATED_DATA = 'SET_UPDATED_DATA';
export const ADD_ROLES_DATA_TENANT = 'ADD_ROLES_DATA_TENANT';
export const UPDATE_ROLES_DATA_TENANT = 'UPDATE_ROLES_DATA_TENANT';
export const GET_USER_PERMISSIONS_TENANT = 'GET_USER_PERMISSIONS_TENANT';

// ChatUtility Books
export const CHATUTILITY_MANAGE_BOOKS_DATA_FETCHED = 'CHATUTILITY_MANAGE_BOOKS_DATA_FETCHED';
export const CHATUTILITY_ADD_BOOK_DATA = 'CHATUTILITY_ADD_BOOK_DATA';
export const CHATUTILITY_EDIT_BOOK_DATA = 'CHATUTILITY_EDIT_BOOK_DATA';

// Identifiers UI Constants
export const IDENTIFIER_DIALOG_EDIT_TITLE = 'Edit Identifier';
export const IDENTIFIER_DIALOG_ADD_TITLE = 'Add New Identifier';
export const IDENTIFIER_FIELD_ID = 'Identifier ID';
export const IDENTIFIER_FIELD_TITLE = 'Title';
export const IDENTIFIER_FIELD_AUTHOR = 'Author';
export const IDENTIFIER_FIELD_STATUS = 'Status';
export const IDENTIFIER_PLACEHOLDER_SELECT = 'Please Select the Status';
export const IDENTIFIER_BUTTON_SAVE = 'Save';
export const IDENTIFIER_BUTTON_CANCEL = 'Cancel';
export const IDENTIFIER_BUTTON_SEARCH = 'Search';
export const IDENTIFIER_BUTTON_ADD = 'Add Identifier';
export const IDENTIFIER_LOADING_SAVING = 'Saving...';
export const IDENTIFIER_LOADING_UPDATING = 'Updating...';
export const IDENTIFIER_LOADING_SEARCHING = 'Searching...';
export const IDENTIFIER_LOADING_LOADING = 'Loading...';
export const OBSERVE_FETCHING_DATA = 'Fetching data...';
export const IDENTIFIER_SEARCH_PLACEHOLDER = 'Search with Identifier ID, Title or Author';
export const IDENTIFIER_STATUS_REVIEW = 'REVIEW';
export const IDENTIFIER_STATUS_DRAFT = 'DRAFT';
export const IDENTIFIER_STATUS_LIVE = 'LIVE';
export const IDENTIFIER_STATUS_PUBLISHED = 'PUBLISHED';
export const IDENTIFIER_FIELD_NAME_ID = 'identifierId';
export const IDENTIFIER_FIELD_NAME_TITLE = 'title';
export const TRENDS_COUNT_NON_TOTAL_COLUMN_IDS = [
  IDENTIFIER_FIELD_NAME_TITLE,
  BOOK_ID_NAME,
  IDENTIFIER_FIELD_NAME_ID,
  CHANNEL_ID_NAME,
  TRENDS_COUNT_DATE_COLUMN_ID
];
export const IDENTIFIER_FIELD_NAME_AUTHOR = 'author';
export const IDENTIFIER_COLUMN_ACTION = 'action';
export const IDENTIFIER_REQUIRED_FIELDS = ['identifierId', 'title', 'author', 'lifeCycleStatus'];
export const PRACTICE_QUESTIONS = 'Practice Questions';
export const FETCH_POPULAR_PAGES_DATA = 'FETCH_POPULAR_PAGES_DATA';
export const SET_POPULAR_PAGES_DATA = 'SET_POPULAR_PAGES_DATA';
export const EXPLAIN_FEATURE = 'explain_feature';
export const SUMMARIZE_FEATURE = 'summarize_feature';
export const PRACTICE_QUESTION_FEATURE = 'practice_questions';
export const MATHJAX_CDN_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=AM_CHTML,TeX-AMS-MML_HTMLorMML';
export const PROMPT_START_COLUMN_NAME = 'promptStart';
export const PROMPT_END_COLUMN_NAME = 'promptEnd';
export const GET_CHATGPT_TYPE_RESPONSE_DATA = 'GET_CHATGPT_TYPE_RESPONSE_DATA';
export const SET_CHATGPT_TYPE_RESPONSE_DATA = 'SET_CHATGPT_TYPE_RESPONSE_DATA';
export const CONTENT_FILTER_TYPE = 'content_filter';
export const CONTENT_CLASSIFIER = 'content_classifier';
export const DICTIONARY_SUMMARY = 'dictionary_summary';
export const DICTIONARY_QUIZ = 'dictionary_quiz';
export const MCQ_MISCONCEPTIONS = 'mcq_misconceptions';
export const MCQ_TYPE = 'mcq';
export const FLASHCARDS = 'flashcards';
export const MCQ_SKILL_INDENTIFIER = 'mcq_skill_identifier';
export const MCQ_DISTRACT = 'mcq_distract';
export const PHYSICS_MCQ = 'physics_mcq';
export const SUMMARY_GPT = 'summary_gpt4o';
export const PHYSICS_MCQ_QUESTION_GENERATION = 'physics_mcq_question_generation';
export const QUIZ_INTENT = 'quiz_intent';
export const QUIZ_VALIDATE_INTENT = 'quiz_validate_intent';
export const SUMMARY_TOPIC = 'summary_topic';
export const AI_STUDY_TOOLS_RESPONSE = 'AI Study Tool Response';
export const PROBLEM_SOLVE_RECTIFIER_TEXT = 'Problem Solve Rectifier';
export const HISTORY_TITLE = 'history_title';
export const CONTEXT_IDENTIFIER_SUMMARY = 'context_identifier_summary';
export const SPECIFIC_TOPIC_INTENT_IDENTIFIER = 'context_identifier_quiz';
export const SUMMARY_TOPIC_IDENTIFIER = 'context_identifier_summary_topic';
export const CHANNEL_FETCH_TYPE = 'channel_fetch';
export const GET_PI_TOKEN_DATA = 'GET_PI_TOKEN_DATA';
export const SET_PI_TOKEN_DATA = 'SET_PI_TOKEN_DATA';
export const GET_AI_CHARTS_UTILITY_LIST_DATA = 'GET_AI_CHARTS_UTILITY_LIST_DATA';
export const SET_AI_CHARTS_UTILITY_LIST_DATA = 'SET_AI_CHARTS_UTILITY_LIST_DATA';
export const GET_AI_CHARTS_UTILITY_DATA = 'GET_AI_CHARTS_UTILITY_DATA';
export const SET_AI_CHARTS_UTILITY_DATA = 'SET_AI_CHARTS_UTILITY_DATA';
export const GET_AI_CHARTS_FEEDBACK_URL = '/chartsutility/getfeedbackdata';
export const GET_AI_CONTENT_FILTER_CHARTS_UTILITY_DATA = 'GET_AI_CONTENT_FILTER_CHARTS_UTILITY_DATA';
export const SET_AI_CONTENT_FILTER_CHARTS_UTILITY_DATA = 'SET_AI_CONTENT_FILTER_CHARTS_UTILITY_DATA';
export const GET_AI_CONTENT_FILTER_CHARTS_FEEDBACK_URL = '/chartsutility/getcontentfilterdata';
export const GET_AI_TOPIC_CHARTS_URL = '/chartsutility/getclusterdata';
export const GET_TRENDING_TOPIC_DATA = 'GET_TRENDING_TOPIC_DATA';
export const SET_TRENDING_TOPIC_DATA = 'SET_TRENDING_TOPIC_DATA';
export const GET_AI_CONTENT_FILTER_CHARTS_DETAILS_DATA = 'GET_AI_CONTENT_FILTER_CHARTS_DETAILS_DATA';
export const SET_AI_CONTENT_FILTER_CHARTS_DETAILS_DATA = 'SET_AI_CONTENT_FILTER_CHARTS_DETAILSDATA';
export const GET_FILE_DATA = 'GET_FILE_DATA';
export const GET_MATHJAX_VERSION_SWITCH = 'mathjax-versioning/mathJaxVersionSwitch.json';
export const CHAT_INTENT_AUDIO = 'chat_intent_audio';
export const GET_TEST_SUITE_DATA = 'GET_TEST_SUITE_DATA';
export const ADD_TEST_SUITE_DATA = 'ADD_TEST_SUITE_DATA';
export const SET_TEST_SUITE_DATA = 'SET_TEST_SUITE_DATA';
export const UPDATE_TEST_SUITE_DATA = 'UPDATE_TEST_SUITE_DATA';
export const UPDATE_TEST_SUITE_DATA_URL = '/chatutility/effectiveness/updateTestSuite';
export const GET_LLM_TEST_RESULTS_DATA = 'GET_LLM_TEST_RESULTS_DATA';
export const SET_LLM_TEST_RESULTS_DATA = 'SET_LLM_TEST_RESULTS_DATA';
export const GET_LLM_RESULTS_BY_EXECUTION_ID_DATA = 'GET_LLM_RESULTS_BY_EXECUTION_ID_DATA';
export const SET_STUDYTOOL_EFFECTIVENESS_EXECUTION_RESULTS = 'SET_STUDYTOOL_EFFECTIVENESS_EXECUTION_RESULTS';
export const S3_EXCLUDED_USERS_LIST_PATH = 'exclude-user-list/tenantConfig.json';
// Trending Topics
export const GET_TRENDING_TOPICS_MODEL_DATA = 'GET_TRENDING_TOPICS_MODEL_DATA';
export const SET_TRENDING_TOPICS_MODEL_DATA = 'SET_TRENDING_TOPICS_MODEL_DATA';
export const EDIT_LLM_TEST_SUITE_TITLE = 'Edit Test Details';
export const ADD_LLM_TEST_SUITE_TITLE = 'Add New Test Suite';
export const CITATION_IMAGES_SUB_TYPE = 'citations_images';
export const ADDITIONAL_CONTEXT_SUB_TYPE = 'additional_context';
export const PROMPT_HISTORY_URL = '/prompts/history';
export const PROMPT_HISTORY_ERROR_MSG = 'History not available for this prompt type.';
export const GET_CLUSTER_LISTING_DATA = 'GET_CLUSTER_LISTING_DATA';
export const SET_CLUSTER_LISTING_DATA = 'SET_CLUSTER_LISTING_DATA';
export const GET_CLUSTER_LISTING_LIST_DATA = 'GET_CLUSTER_LISTING_LIST_DATA';
export const SET_CLUSTER_LISTING_LIST_DATA = 'SET_CLUSTER_LISTING_LIST_DATA';
export const DEFAULT_CHANNEL_ID = 'general-chemistry';
export const TOGGLE_BUTTON_COUNT = 'count';
export const TOGGLE_BUTTON_FEEDBACK = 'userFeedBack';
export const TOGGLE_BUTTON_BLOCKED_COUNT = 'blockedCount';
export const CONTENT_FILTER_RESPONSE = 'Content Filter Response';
export const CHAT_INTENT_RESPONSE = 'Chat Intent Response';
export const EXPLAIN_STAND_ALONE_PROMPT = 'Explain Standalone Prompt';
export const EXPLAIN_STAND_ALONE_RESPONSE = 'Explain Standalone Response';

// Observe

export const FETCH_OBSERVE_TYPES = 'FETCH_OBSERVE_TYPES';
export const SET_OBSERVE_TYPES = 'SET_OBSERVE_TYPES';
export const GET_TYPES_URL = '/types';
export const GET_OBSERVE_SEARCH_DATA = 'GET_OBSERVE_SEARCH_DATA';
export const GET_OBSERVE_SEARCH_RESPONSE = 'GET_OBSERVE_SEARCH_RESPONSE';
export const OBSERVE_SEARCH_STATUS = 'observeSearchStatus';
export const EXCLUDE_USER_ID_KEY = 'excludeUserId';
export const AUDIO_INTENT_KEY = 'audioIntent';
export const DISPLAY_TYPE_KEY = 'displayType';
export const START_DATE_TIME_KEY = 'startDateTime';
export const START_DATE_KEY = 'startDate';
export const END_DATE_KEY = 'endDate';
export const GRAPH_ID_KEY = 'graphId';
export const GRAPH_VERSION_KEY = 'graphVersion';
export const AGENT_NAME_KEY = 'agentName';
export const AUDIT_GRAPH_ALL_VERSIONS_VALUE = '__ALL_VERSIONS__';
export const EXECUTION_ID_KEY = 'executionId';
export const RUBRIC_ID_KEY = 'rubricId';
export const AUTOCOMPLETE_COMPONENT = 'AutocompleteComponent';
export const ENTITY_IDENTIFIER_FIELD = 'EntityIdentifierField';
export const CUSTOM_TEXT_FIELD_COMPONENT = 'CustomTextField';
export const AUDIT_GRAPH_ID_FIELD_COMPONENT = 'AuditGraphIdField';
export const AUDIT_GRAPH_VERSION_FIELD_COMPONENT = 'AuditGraphVersionField';
export const OBSERVE_ENTITY_COURSES = 'courses';
export const OBSERVE_ENTITY_BOOK_ID = 'bookId';
export const OBSERVE_ENTITY_GRAPH = 'graph';
export const OBSERVE_ENTITY_GRAPHS = 'graphs';
export const OBSERVE_SEARCH_FIELD_GRAPH_ID = 'graphId';
export const OBSERVE_SEARCH_FIELD_REQUEST_ID = 'requestId';
export const OBSERVE_URL_BOOK_ID_PREFILL_ENTITY_TYPES = [OBSERVE_ENTITY_COURSES, OBSERVE_ENTITY_BOOK_ID];
export const OBSERVE_SEARCH_ENDPOINT = '/audit/observe';
export const OTEL_MODES = Object.freeze({ ON: 'on', OFF: 'off', STRICT: 'strict' });
export const OBSERVE_EXPORT_ENDPOINT = '/audit/observe/export';
export const GET_OBSERVE_EXPORT_DATA = 'GET_OBSERVE_EXPORT_DATA';

// Telemetry (v3 observe)
export const GET_TELEMETRY_SEARCH_DATA = 'GET_TELEMETRY_SEARCH_DATA';
export const GET_TELEMETRY_SEARCH_RESPONSE = 'GET_TELEMETRY_SEARCH_RESPONSE';
export const TELEMETRY_SEARCH_STATUS = 'telemetrySearchStatus';
export const GET_TELEMETRY_DETAIL = 'GET_TELEMETRY_DETAIL';
export const GET_TELEMETRY_DETAIL_RESPONSE = 'GET_TELEMETRY_DETAIL_RESPONSE';
export const TELEMETRY_DETAIL_STATUS = 'telemetryDetailStatus';
export const TELEMETRY_SEARCH_ENDPOINT = '/audit/otel/observe';
export const TELEMETRY_ROUTE_PATH = 'observe/telemetry';

// User Feedback

export const GET_FEEDBACK_DATA = 'GET_FEEDBACK_DATA';
export const GET_FEEDBACK_RESPONSE = 'GET_FEEDBACK_RESPONSE';
export const FEEDBACK_SEARCH_STATUS = 'feedbackSearchStatus';

// Configuration
export const GET_TENANT_FEATURE_DATA = 'GET_TENANT_FEATURE_DATA';
export const UPDATE_TENANT_FEATURE_DATA = 'UPDATE_TENANT_FEATURE_DATA';
export const ADD_TENANT_FEATURE_DATA = 'ADD_TENANT_FEATURE_DATA';
export const SET_TENANT_FEATURE_DATA = 'SET_TENANT_FEATURE_DATA';
export const TENANT_FEATURE_ADD_FAILED = 'TENANT_FEATURE_ADD_FAILED';

// Root Path
export const AI_ADMIN_PATH = '/aiadmin';
export const BERLIN_TENANT_ID_HEADER = 'x-berlin-tenant-id';
export const BERLIN_TENANT_KEY_HEADER = 'x-berlin-tenant-key';
export const USER_LAST_ACCESSED_HEADER = 'x-user-last-accessed';
export const REQUEST_ID_HEADER = 'x-request-id';
export const THREAD_ID_HEADER = 'x-thread-id';
export const TENANT_ID = 'tenantId';

// Common Paths

export const CONFIGURATION_PATH = `${AI_ADMIN_PATH}/tenants`;
export const USER_MANAGEMENT_PATH = `${AI_ADMIN_PATH}/users`;
export const USER_ROLES_PATH = `${AI_ADMIN_PATH}/roles`;
export const USER_MANAGEMENT_TAB_KEY = 'users';

/**  user management */
export const USER_MANAGEMENT_TABLE_ACTION = Object.freeze({
  EDIT: 'edit',
  DELETE: 'delete'
});

export const USER_ROLE_FILTER_ALL = 'ALL';
export const USER_SEARCH_MIN_LENGTH = 3;

// AI Study Tools Paths
export const AI_STUDYTOOLS_PATH = `${AI_ADMIN_PATH}/aistudytools`;
export const AI_STUDY_TOOLS_OBSERVE_PATH = `${AI_STUDYTOOLS_PATH}/observe`;
export const AI_STUDY_TOOLS_TRENDS_PATH = `${AI_STUDYTOOLS_PATH}/trends`;
export const AI_STUDY_TOOLS_LLM_EVAL_PATH = `${AI_STUDYTOOLS_PATH}/promptmgt/effectiveness`;
export const AI_STUDY_TOOLS_PRMPT_MGMT = `${AI_STUDYTOOLS_PATH}/promptmgt`;
export const AI_STUDY_TOOLS_CONTENT_MGMT = `${AI_STUDYTOOLS_PATH}/titlesearch`;
export const AI_STUDY_TOOLS_MCQ_PATH = `${AI_STUDYTOOLS_PATH}/mcq`;
export const AI_STUDY_TOOLS_MCQ_VIEW_PATH = `${AI_STUDY_TOOLS_MCQ_PATH}/view/:bookId`;
export const AI_STUDY_TOOLS_MCQ_ADD_PATH = `${AI_STUDY_TOOLS_MCQ_PATH}/add/:bookId`;
export const AI_STUDY_TOOLS_MCQ_EDIT_PATH = `${AI_STUDY_TOOLS_MCQ_PATH}/edit/:bookId`;
export const AI_STUDY_TOOLS_SUMMARY_PATH = `${AI_STUDYTOOLS_PATH}/summary`;
export const AI_STUDY_TOOLS_SUMMARY_VIEW_PATH = `${AI_STUDY_TOOLS_SUMMARY_PATH}/view/:bookId`;
export const AI_STUDY_TOOLS_SUMMARY_ADD_PATH = `${AI_STUDY_TOOLS_SUMMARY_PATH}/add/:bookId`;
export const AI_STUDY_TOOLS_SUMMARY_EDIT_PATH = `${AI_STUDY_TOOLS_SUMMARY_PATH}/edit/:bookId`;

// Channels Paths
export const CHANNELS_PATH = `${AI_ADMIN_PATH}/channels`;
export const CHANNELS_OBSERVE_PATH = `${CHANNELS_PATH}/observe`;
export const CHANNELS_TRENDS_PATH = `${CHANNELS_PATH}/trends`;
export const CHANNELS_PRMPT_MGMT = `${CHANNELS_PATH}/promptmgt`;

export const CURRENT_SECTION = 'currentsection';
export const CURRENT_CHAPTER = 'currentchapter';
export const CONFIGS = 'Configs';

// PVS Paths
export const PVS_PATH = `${AI_ADMIN_PATH}/pvs`;
export const PVS_INGESTION_PATH = `${PVS_PATH}/ingestion`;
export const GET_TENANTS_CONFIG_DATA_URL = '/tenants';
export const GET_TENANT_CONFIG_DATA = 'GET_TENANT_CONFIG_DATA';
export const ENV_DEV = 'dev';
export const ENV_PROD = 'prod';
export const ENV_STG = 'stg';
export const SET_TENANT_CONFIG_DATA = 'SET_TENANT_CONFIG_DATA';
export const SET_TENANT_DATA = 'SET_TENANT_DATA';
export const BLOCKED = 'BLOCKED';
// Audit Row Payload for tenants

export const GET_SEARCH_INGESTION_RESPONSE = 'GET_SEARCH_INGESTION_RESPONSE';
export const SET_SEARCH_INGESTION_RESPONSE = 'SET_SEARCH_INGESTION_RESPONSE';
export const COURSE_ID = 'Course Id';
export const MANIFEST_ID = 'Manifest Id';
export const TRACKING_ID = 'Tracking Id';
export const AI_INDEXING = 'AI Indexing';
export const MCQ_GENERATION = 'MCQ Generation';
export const TOPICS_GENERATION = 'Topics Generation';
export const IMAGE_EXTRACTION = 'Image Extraction';
export const SUMMARY_GENERATION = 'Summary Generation';
export const ALL_COURSES = 'All Courses';
export const DEFAULT_DATE_RANGE_DAYS_KEY = 'defaultDateRangeDays';
export const BLOCKED_CHART_HEADER = 'Blocked Content - Saftey Trend Chart';
// Modal Constants
export const AI_STUDY_TOOL_TITLE = 'AI Study Tool';
export const RESPONSE_LABEL = 'Response';
export const BOT_RESPONSE_LABEL = 'Bot Response';
export const FINAL_SUMMARY_LABEL = 'Final Summary';
export const PROCESSED_SUMMARY_LABEL = 'Processed Summary';
export const FLASHCARDS_LABEL = 'Flashcards';
export const FLASHCARD_TYPE_LABEL = 'Type';
export const FLASHCARD_FRONT_LABEL = 'Front Side';
export const FLASHCARD_BACK_LABEL = 'Back Side';
export const FLASHCARD_DISTRACTORS_LABEL = 'Distractors';
export const QUESTION_LABEL = 'Question';
export const CORRECT_LABEL = '(Correct)';
export const INCORRECT_LABEL = 'Incorrect';
export const QUESTION_TYPE_LABEL = 'Question Type';
export const TOPIC_LABEL = 'Topic';
export const STEP_BY_STEP_LABEL = 'Step by Step';
export const STEP_LABEL = 'Step';
export const SOLVE_LABEL = 'Solve';
export const ANSWER_LABEL = 'Answer';
export const RAW_RESPONSE_LABEL = 'Raw Response';
export const SWITCH_COLOR = '#ffffff';
export const CHANNELS_TITLE = 'Channels';
export const ROLE_LABEL = 'Role';
export const CONTENT_LABEL = 'Content';
export const BOOK_ID_LABEL = 'Book ID';
export const QUESTION_ID_LABEL = 'Question ID';
export const PAGE_ID_LABEL = 'Page ID';
export const OPTIONS_LABEL = 'Options';
export const EXPLANATORY_LABEL = 'Explanatory';
export const CORRECTIVE_LABEL = 'Corrective';
export const FEEDBACK_LABEL = 'Feedback for option';
export const CATEGORY_LABEL = 'Category';
export const SEVERITY_LABEL = 'Severity';
export const PROBLEM_SOLVE_LABEL = 'Problem Solve';
export const PROBLEM_SOLVE_VERIFIER_LABEL = 'Problem Solve Verifier';
export const PROBLEM_SOLVE_RECTIFIER_LABEL = 'Problem Solve Rectifier';
export const QUIZ_MCQ = 'quiz_mcq';
export const AET_MCQS_TYPE = 'aet_mcqs';
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 100;
export const DEFAULT_TOTAL = 0;
export const GREEN_COLOR = 'green';
export const INHERIT = 'inherit';
export const EXPLANATION_LABEL = 'Explaination';
export const CONCEPT_LABEL = 'Concepts';
export const TOPIC_ID = 'TOPIC_ID';
export const TRENDS_LABEL = 'trends';
export const OBSERVE_LABEL = 'observe';

// Controls
export const SEARCH_ACTION = 'search';
export const RESET_ACTION = 'reset';
export const SAVE_ACTION = 'save';
export const REDIRECT_ACTION = 'redirect';
export const RUN_TEST_ACTION = 'runTest';
export const GET_RESULTS_ACTION = 'getResults';
export const REFRESH_ACTION = 'refresh';
export const SHOW_REPORT_ACTION = 'showReport';
export const SHOW_RESULT_ACTION = 'showResult';
export const STATUS_INFO_ACTION = 'statusInfo';

// Sort
export const ASC_SORT = 'asc';
export const DESC_SORT = 'desc';

// Boolean
export const YES_BOOL = 'Yes';
export const NO_BOOL = 'No';
export const TRUE_BOOL = 'true';
export const FALSE_BOOL = 'false';

// Status
export const FAILED_STATUS = 'Failed';
export const IN_PROGRESS_STATUS = 'In Progress';
export const SCHEDULED_STATUS = 'Scheduled';

export const TOOL_CALL_OUTPUT = 'Tool Call Output';
export const CONTEXT_LABEL = 'context';

// PROMPT
export const GET_PROMPT_TYPES_DATA = 'GET_PROMPT_TYPES_DATA';
export const SET_PROMPT_TYPES_DATA = 'SET_PROMPT_TYPES_DATA';
export const GET_PROMPT_PROPERTIES_URL = '/chatutility/prompt/getpromptproperties';
export const SELECT_PLACEHOLDER_STATUS = 'Select Status';
export const SAVE_PROPERTIES_ADMIN_DATA = 'SAVE_PROPERTIES_ADMIN_DATA';
export const SET_PROPERTIES_ADMIN_DATA = 'SET_PROPERTIES_ADMIN_DATA';
export const GET_PROPERTIES_ADMIN_DATA = 'GET_PROPERTIES_ADMIN_DATA';
export const EDIT_PROPERTIES_ADMIN_DATA = 'EDIT_PROPERTIES_ADMIN_DATA';
export const GET_MODEL_PROPERTIES_ADMIN_DATA = 'GET_MODEL_PROPERTIES_ADMIN_DATA';
export const SET_MODEL_PROPERTIES_ADMIN_DATA = 'SET_MODEL_PROPERTIES_ADMIN_DATA';
export const GET_PROMPT_VERSION_DATA = 'GET_PROMPT_VERSION_DATA';
export const SET_PROMPT_VERSION_DATA = 'SET_PROMPT_VERSION_DATA';
export const ADMIN_PROMPT_LIVE_STATUS_PUBLISH_TEXT =
  'Previous version of same prompt is already LIVE. To make this new edits LIVE, click on “Publish”';

export const SELECT_PLACEHOLDER_TYPE = 'Select Type';
export const BUTTON_LABEL = 'Button';
export const REDIRECT_LABEL = 'redirect';
export const NO_DATA_FOUND = 'No Data Found';
export const AI_STUDY_FEEDBACK_LABEL = 'Feedback and Request tabs';
export const REQUEST_TAB = 'Request';
export const FEEDBACK_TAB = 'Feedback';
export const TAB_LABELS = [REQUEST_TAB, FEEDBACK_TAB];
export const AI_STUDY_TOOL_KEY = 'aiStudyTools';
export const EXPLAIN_SUGGESTIONS_LABEL = 'Suggestions';
/** Card labels for agentic response items that carry a `name` but no `displayType`. */
export const AGENT_NAME_DISPLAY_LABELS = {
  [PROBLEM_SOLVE]: PROBLEM_SOLVE_LABEL,
  [PROBLEM_SOLVE_VERIFIER]: PROBLEM_SOLVE_VERIFIER_LABEL,
  [PROBLEM_SOLVE_RECTIFIER]: PROBLEM_SOLVE_RECTIFIER_LABEL,
  [GENERATE_PYTHON]: GENERATE_PYTHON_AI_RESPONSE,
  [PROBLEM_SOLVE_FINAL_RESPONSE]: PROBLEM_SOLVE_FINAL_AI_RESPONSE,
  [EXPLAIN_SUGGESTIONS]: EXPLAIN_SUGGESTIONS_LABEL
};
export const PROBLEM_SOLVE_FINAL_RESPONSE_KEY = 'problemSolveFinalRes';
export const PROBLEM_SOLVE_RECTIFIER_KEY = 'problemSolveRawRectifier';
export const FEEDBACK_TITLE = 'Feedback and Comments';
export const DISLIKE_REASON = 'Reason for Dislike';
export const LIKE_TEXT = 'Like';
export const DISLIKE_TEXT = 'Dislike';
export const VERSION_TEXT = 'Version';
export const GRAPH_ID = 'Graph ID';
export const NAME = 'Name';
export const KEY_SHOW_TAB = 'showTab';
export const NEXT = 'next';
export const PREV = 'prev';
export const TOPICS = 'Topics';
export const DETAIL_LABEL = 'detail';
export const FEEDBACK_URL_LABEL = 'feedback';

// Agentic
export const AGENTIC_LIVE_PUBLISH_LABEL =
  'There is already a LIVE version exist for this Graph, any changes will create a new version. Are you sure, you want to proceed?';

// Error message templates

export const ERROR_MESSAGE_TEMPLATE = 'Please select any {{placeholder}}';
export const placeholders = {
  [AI_STUDY_TOOL]: 'Book Id',
  [CHANNELS]: 'Channel Id',
  [PVS]: 'Course Id',
  [ECOMM]: 'Graph Id',
  [ELS]: 'Graph Id'
};

export const AUTOCOMPLETE_REASON_KEYS = ['input', 'clear'];
export const JUSTIFICATION_LABEL = 'Justification';
export const DEFAULT_SHOW_OUTLINE = '1D';
export const permissions = Object.freeze({
  ADMIN_CAN_VIEW: 'admin_can_view',
  ADMIN_CAN_EDIT: 'admin_can_edit',
  USER_CAN_VIEW: 'user_can_view',
  USER_CAN_ADD: 'user_can_add',
  USER_CAN_DELETE: 'user_can_delete',
  USER_CAN_EDIT: 'user_can_edit',
  ROLE_CAN_ADD: 'role_can_add',
  ROLE_CAN_EDIT: 'role_can_edit',
  ROLE_CAN_DELETE: 'role_can_delete',
  EVAL_CAN_VIEW: 'eval_can_view',
  EVAL_CAN_EDIT: 'eval_can_edit',
  NO_ACCESS_RESTRICTED: 'no_access_restricted'
});

export const URL_PARAMS = {
  IDENTIFIER_ID: 'identifierid',
  REQUEST_ID: 'requestid',
  USER_ID: 'userid',
  TYPE: 'type',
  FROM_AGENTIC: 'fromagentic',
  AUDIO_INTENT: 'audiointent',
  CREATED_DATE: 'createddate',
  TRACE_ID: 'traceid',
  SDK: 'sdk'
};

export const MODULE_TYPES = Object.freeze({
  FEEDBACK: 'feedback',
  OBSERVE: 'observe'
});

export const FEEDBACK_LOGS_ENDPOINT = '/audit/feedback';
export const FEEDBACK_EXPORT_ENDPOINT = '/audit/feedback/export';
export const GET_FEEDBACK_EXPORT_DATA = 'GET_FEEDBACK_EXPORT_DATA';

export const TRENDS_CLUSTERS_EXPORT_ENDPOINT = '/trends/clusters/export';
export const GET_TRENDS_CLUSTERS_EXPORT_DATA = 'GET_TRENDS_CLUSTERS_EXPORT_DATA';
export const TRENDS_CLUSTERS_EXPORT_STATUS = 'trendsClustersExportStatus';

export const TRENDS_COUNT_EXPORT_ENDPOINT = '/trends/count/export';
export const GET_TRENDS_COUNT_EXPORT_DATA = 'GET_TRENDS_COUNT_EXPORT_DATA';
export const TRENDS_COUNT_EXPORT_STATUS = 'trendsCountExportStatus';

export const SEARCH_LIST_EXPORT_ENDPOINT = '/search/list/export';
export const GET_SEARCH_LIST_EXPORT_DATA = 'GET_SEARCH_LIST_EXPORT_DATA';
export const SEARCH_LIST_EXPORT_STATUS = 'searchListExportStatus';

export const TRENDS_FEEDBACK_CHARTS_EXPORT_PATH = '/trends/count/feedback';
export const GET_TRENDS_FEEDBACK_CHARTS_EXPORT_DATA = 'GET_TRENDS_FEEDBACK_CHARTS_EXPORT_DATA';
export const TRENDS_FEEDBACK_CHARTS_EXPORT_STATUS = 'trendsFeedbackChartsExportStatus';

export const TRENDS_BLOCKED_CHARTS_EXPORT_PATH = '/trends/count/blocked';
export const GET_TRENDS_BLOCKED_CHARTS_EXPORT_DATA = 'GET_TRENDS_BLOCKED_CHARTS_EXPORT_DATA';
export const TRENDS_BLOCKED_CHARTS_EXPORT_STATUS = 'trendsBlockedChartsExportStatus';

/** Framework HTTP clients used by audit exports; v2 unless a module opts into the v1 pair. */
export const AUDIT_EXPORT_DEFAULT_CLIENTS = Object.freeze({
  default: 'aiadminv2',
  stackB: 'aiadminstackbv2'
});
export const AUDIT_EXPORT_V1_CLIENTS = Object.freeze({
  default: 'aiadmin',
  stackB: 'aiadminstackb'
});
/** Observe + OTEL merged export (v3 audit/observe/export). */
export const AUDIT_EXPORT_V3_CLIENTS = Object.freeze({
  default: 'aiadminv3',
  stackB: 'aiadminstackbv3'
});

export const AUDIT_EXPORT_MODULE = Object.freeze({
  OBSERVE: 'observe',
  FEEDBACK: 'feedback',
  TRENDS_CLUSTER: 'trendsCluster',
  TRENDS_COUNT: 'trendsCount',
  TITLE_SEARCH: 'titleSearch',
  TRENDS_FEEDBACK: 'trendsFeedback',
  TRENDS_BLOCKED: 'trendsBlocked',
  OTEL_TRENDS_COUNT: 'otelTrendsCount'
});

export const TRACKING_ID_FIELD = 'trackingId';
export const TITLE_SEARCH_ID_FIELD = 'id';

export const TITLE_SEARCH_BOUND_ID_FIELDS = Object.freeze([
  TITLE_SEARCH_ID_FIELD,
  TRACKING_ID_FIELD,
  IDENTIFIER_FIELD_NAME_ID,
  OBSERVE_SEARCH_FIELD_GRAPH_ID
]);

export const TRENDS_COUNT_BOUND_ID_FIELDS = Object.freeze([IDENTIFIER_FIELD_NAME_ID, BOOK_ID_NAME]);

/** Observe/Feedback export APIs expect `displayType`; trends feedback/blocked/cluster use `type`. */
export const MODULES_WITH_TYPE_DISPLAY_TYPE_OVERRIDE = Object.freeze([
  AUDIT_EXPORT_MODULE.OBSERVE,
  AUDIT_EXPORT_MODULE.FEEDBACK
]);

export const AUDIT_EXPORT_EVENTS = Object.freeze({
  [AUDIT_EXPORT_MODULE.OBSERVE]: GET_OBSERVE_EXPORT_DATA,
  [AUDIT_EXPORT_MODULE.FEEDBACK]: GET_FEEDBACK_EXPORT_DATA,
  [AUDIT_EXPORT_MODULE.TRENDS_CLUSTER]: GET_TRENDS_CLUSTERS_EXPORT_DATA,
  [AUDIT_EXPORT_MODULE.TRENDS_COUNT]: GET_TRENDS_COUNT_EXPORT_DATA,
  [AUDIT_EXPORT_MODULE.TITLE_SEARCH]: GET_SEARCH_LIST_EXPORT_DATA,
  [AUDIT_EXPORT_MODULE.TRENDS_FEEDBACK]: GET_TRENDS_FEEDBACK_CHARTS_EXPORT_DATA,
  [AUDIT_EXPORT_MODULE.TRENDS_BLOCKED]: GET_TRENDS_BLOCKED_CHARTS_EXPORT_DATA,
  [AUDIT_EXPORT_MODULE.OTEL_TRENDS_COUNT]: GET_OTEL_TRENDS_COUNT_EXPORT_DATA
});
export const OBSERVE_EXPORT_STATUS = 'observeExportStatus';
export const FEEDBACK_EXPORT_STATUS = 'feedbackExportStatus';

export const FEEDBACK_DETAILED_LOG_ENDPOINT = '/audit/feedback';

// Feedback Detailed Log Events
export const GET_FEEDBACK_DETAILED_LOG = 'GET_FEEDBACK_DETAILED_LOG';
export const GET_FEEDBACK_DETAILED_LOG_RESPONSE = 'GET_FEEDBACK_DETAILED_LOG_RESPONSE';
export const FEEDBACK_DETAILED_LOG_STATUS = 'feedbackDetailedLogStatus';

// Server-side pagination defaults
export const PAGINATION = {
  ROW_PER_PAGE: [100, 200, 500],
  DEFAULT_PAGE: 0,
  DEFAULT_TOTAL_ITEMS: 0,
  OFFSET: 0,
  LIMIT: 100
};

export const STORE_NAMES = ['feedbackLogs', 'observeSearch', 'bookTitles', 'observeTypes', 'feedbackDetailedLog'];

// Feedback Modal Constants
export const FEEDBACK_DIALOG_TITLE = 'Feedback/Comment';
export const ADD_COMMENT_TAB_LABEL = 'Add Comment';
export const COMMENT_HISTORY_TAB_LABEL = 'Comment History';
export const SECTION_HEADING_TEXT = 'What was wrong with the Content?';
export const COMMENT_PLACEHOLDER = 'Please explain...';
export const LOADER_TEXT = 'Submitting feedback...';
export const ADDED_BY_LABEL = 'Added By:';
export const UPDATED_AT_LABEL = 'Updated At:';
export const COMMENT_LABEL = 'Comment:';
export const REASONS_LABEL = 'Reasons:';
export const NO_FEEDBACK_HEADING = 'No Feedback Available';
export const NO_FEEDBACK_MESSAGE_PREFIX = 'This';
export const NO_FEEDBACK_MESSAGE_SUFFIX = 'does not have any feedback comments yet.';
export const VIEW_TYPE_QUIZ = 'quiz';
export const VIEW_TYPE_AET = 'aetquiz';
export const VIEW_TYPE_AET_TOPIC = 'aettopic';
export const VIEW_TYPE_SUMMARY = 'summary';
export const VIEW_TYPE_DISPLAY_QUIZ = 'question';
export const VIEW_TYPE_DISPLAY_SUMMARY = 'summary';
export const CANCEL_BUTTON_LABEL = 'Cancel';
export const SUBMIT_BUTTON_LABEL = 'Submit';
export const DATE_NOT_AVAILABLE = 'N/A';
export const DATE_LOCALE = 'en-US';
export const TIMESTAMP_THRESHOLD = 10000000000;

// Placeholder text fetching events
export const FETCH_AET_QUIZ_PLACEHOLDER = 'FETCH_AET_QUIZ_PLACEHOLDER';
export const SET_AET_QUIZ_PLACEHOLDER = 'SET_AET_QUIZ_PLACEHOLDER';
export const FETCH_AET_TOPIC_PLACEHOLDER = 'FETCH_AET_TOPIC_PLACEHOLDER';
export const SET_AET_TOPIC_PLACEHOLDER = 'SET_AET_TOPIC_PLACEHOLDER';

// API URLs for placeholder text
export const AET_QUIZ_PLACEHOLDER_URL = 'cm/quiz-aet/placeholder';
export const AET_TOPIC_PLACEHOLDER_URL = 'cm/topic-aet/placeholder';
export const DEFAULT_COMMENT_PLACEHOLDER = 'Please provide your comment...';

// Text Content fetching events (technical constants)
export const FETCH_TEXT_CONTENT = 'FETCH_TEXT_CONTENT';
export const SET_TEXT_CONTENT = 'SET_TEXT_CONTENT';
export const TEXT_CONTENT_URL = 'cm/quiz-aet/textcontent';

// System-to-System Token Operations
export const GET_SYS2SYS_TOKEN = 'GET_SYS2SYS_TOKEN';
export const GET_SYS2SYS_TOKEN_SUCCESS = 'GET_SYS2SYS_TOKEN_SUCCESS';
export const GET_SYS2SYS_TOKEN_ERROR = 'GET_SYS2SYS_TOKEN_ERROR';

export const INITIAL_MCP_SERVER_CONFIG_FORM_STATE = {
  mcpServerName: '',
  mcpServerUrl: '',
  mcpAuthType: '',
  isInternalMcpServer: false,
  mcpToolList: []
};

export const MCP_FORM_FIELDS = Object.freeze({
  MCP_SERVER_NAME: 'mcpServerName',
  MCP_SERVER_URL: 'mcpServerUrl',
  MCP_AUTH_TYPE: 'mcpAuthType'
});

export const MCP_AUTH_TYPE = Object.freeze({
  NONE: 'None',
  IES: 'IES',
  OAUTH: 'OAuth'
});

export const MCP_AUTH_TYPES = Object.freeze([MCP_AUTH_TYPE.NONE, MCP_AUTH_TYPE.IES, MCP_AUTH_TYPE.OAUTH]);

export const JSON_VALIDATION_ERROR_CODE = Object.freeze({
  JSON_OBJECT_REQUIRED: 'JSON_OBJECT_REQUIRED',
  PARSE_ERROR: 'PARSE_ERROR'
});
